var _mask, _g, _path, _mask2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstacionamiento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ygy72eq1ra",
    width: 34,
    height: 15,
    x: 16,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.049 0h33.95v14.58H16.05V0z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ygy72eq1ra)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M49.104 11.51L26.427.17c-.456-.227-.993-.227-1.45 0l-8.033 4.017c-.8.401-1.124 1.374-.724 2.174.4.8 1.373 1.123 2.174.725l7.308-3.655 21.954 10.976c.232.117.479.172.723.172.593 0 1.166-.329 1.45-.896.4-.8.076-1.773-.725-2.174",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M3.026 14.579c.244 0 .49-.055.723-.171l7.322-3.662c.8-.4 1.125-1.373.725-2.174-.401-.799-1.376-1.124-2.173-.724L2.3 11.51c-.8.401-1.124 1.374-.725 2.174.285.568.857.896 1.45.896",
    clipRule: "evenodd"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b0c72xp08b",
    width: 49,
    height: 50,
    x: 1,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1 49.405h49V0H1v49.405z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#6C7281",
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b0c72xp08b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.017 46.165h3.24v-4.05h-3.24v4.05zm-22.678 0h3.24v-4.05h-3.24v4.05zm6.48 0h12.958v-4.05H18.818v4.05zm29.156 0h-6.48v-4.05h4.86c.895 0 1.62-.725 1.62-1.619V35.23c0-3.27-2.054-6.062-4.935-7.173l-3.854-11.56c-.221-.662-.84-1.108-1.537-1.108H34.45c-.894 0-1.62.725-1.62 1.62 0 .894.726 1.62 1.62 1.62h2.032l2.969 8.908H11.549l2.97-8.909h12.862c.895 0 1.62-.725 1.62-1.62 0-.894-.725-1.62-1.62-1.62H13.35c-.697 0-1.316.447-1.536 1.109L7.96 28.057c-2.882 1.11-4.936 3.903-4.936 7.173 0 .894.725 1.62 1.62 1.62.895 0 1.62-.726 1.62-1.62 0-2.456 1.998-4.453 4.452-4.453h29.566c2.455 0 4.453 1.997 4.453 4.453v3.646H4.645c-.895 0-1.62.726-1.62 1.62 0 .894.725 1.62 1.62 1.62h4.454v4.05H2.62c-.893 0-1.619.725-1.619 1.62 0 .893.726 1.62 1.62 1.62h45.356c.894 0 1.619-.727 1.619-1.62 0-.895-.725-1.62-1.62-1.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.256 34.826c0-.894-.725-1.62-1.62-1.62-.895 0-1.62.726-1.62 1.62 0 .895.726 1.62 1.62 1.62.895 0 1.62-.725 1.62-1.62M15.579 34.826c0-.894-.726-1.62-1.62-1.62-.895 0-1.62.726-1.62 1.62 0 .895.725 1.62 1.62 1.62.894 0 1.62-.725 1.62-1.62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstacionamiento);
export default __webpack_public_path__ + "static/media/estacionamiento.5024332a603ca1120c8f7852e47be353.svg";
export { ForwardRef as ReactComponent };